import { client } from '@/common-utils/libraries/axios/axios';
import { CONTRACTS } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateContractLabel = (onSuccess, onError) => {
    return {
        mutationFn: ({ contractAccessId, contractId, label }) => {
            return client.put(
                replaceParameters(CONTRACTS.UPDATE_CONTRACT.url, { contractAccessId, contractId }),
                { merchantLabel: label }
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateContractLabel;